<template>
	<div class="active">
        <img :src="`${httpImg}/avatar/20250923.png`" />
    </div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
	// import Clipboard from 'clipboard'
	export default {
		data() {
			return {
				locale: '',
			}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg
			}),
		},
		created() {
			// document.title = this.$t('activityXP.title');
			// this.locale = this.$i18n.locale
		},

	}
</script>

<style scoped lang="less">
	.active {
        img{
            width: 100%;
            height: auto;
        }
    }
</style> 